import React from 'react';
export { reducer } from './MaintenanceOverviewReducer';

export const MaintenanceOverviewLazyV2 = React.lazy(() => import(/* webpackChunkName: "CBM" */ './MaintenanceOverviewContainer'));
